/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CreateExternalDealFilterDTO,
  DeleteManyExternalDealFiltersDTO,
  DeleteManyExternalDealFiltersResponseDTO,
  DuplicateExternalDealFiltersDTO,
  ExternalDealFilterListResponseDTO,
  ExternalDealFilterListResponseMvoDTO,
  ExternalDealFilterMvoDTO,
  InExternalDealFilterDTO,
  OutExternalDealFilterDTO,
  PatchManyExternalDealFiltersDTO,
  PatchManyExternalDealFiltersLiveDTO,
  PatchManyExternalDealFiltersSearchQueryDTO
} from "../models";
import {
  CreateExternalDealFilterDTOFromJSON,
  CreateExternalDealFilterDTOToJSON,
  DeleteManyExternalDealFiltersDTOFromJSON,
  DeleteManyExternalDealFiltersDTOToJSON,
  DeleteManyExternalDealFiltersResponseDTOFromJSON,
  DeleteManyExternalDealFiltersResponseDTOToJSON,
  DuplicateExternalDealFiltersDTOFromJSON,
  DuplicateExternalDealFiltersDTOToJSON,
  ExternalDealFilterListResponseDTOFromJSON,
  ExternalDealFilterListResponseDTOToJSON,
  ExternalDealFilterListResponseMvoDTOFromJSON,
  ExternalDealFilterListResponseMvoDTOToJSON,
  ExternalDealFilterMvoDTOFromJSON,
  ExternalDealFilterMvoDTOToJSON,
  InExternalDealFilterDTOFromJSON,
  InExternalDealFilterDTOToJSON,
  OutExternalDealFilterDTOFromJSON,
  OutExternalDealFilterDTOToJSON,
  PatchManyExternalDealFiltersDTOFromJSON,
  PatchManyExternalDealFiltersDTOToJSON,
  PatchManyExternalDealFiltersLiveDTOFromJSON,
  PatchManyExternalDealFiltersLiveDTOToJSON,
  PatchManyExternalDealFiltersSearchQueryDTOFromJSON,
  PatchManyExternalDealFiltersSearchQueryDTOToJSON
} from "../models";

export interface CreateExternalDealFilterRequest {
  createExternalDealFilterDTO: CreateExternalDealFilterDTO;
}

export interface DeleteExternalDealFilterRequest {
  externalDealFilterId: number;
}

export interface DeleteManyExternalDealFiltersRequest {
  deleteManyExternalDealFiltersDTO: DeleteManyExternalDealFiltersDTO;
}

export interface DuplicateManyExternalDealFilterRequest {
  duplicateExternalDealFiltersDTO: DuplicateExternalDealFiltersDTO;
}

export interface GetExternalDealFilterByIdRequest {
  externalDealFilterId: number;
}

export interface GetExternalDealFiltersRequest {
  skip?: number;
  take?: number;
  filterQuery?: string;
  sortBy?: GetExternalDealFiltersSortByEnum;
  sortOrder?: GetExternalDealFiltersSortOrderEnum;
}

export interface PatchExternalDealFilterRequest {
  externalDealFilterId: number;
  externalDealFilterMvoDTO: ExternalDealFilterMvoDTO;
}

export interface PatchManyEdfsAddMerchantsAndCategoriesRequest {
  patchManyExternalDealFiltersDTO: PatchManyExternalDealFiltersDTO;
}

export interface PatchManyEdfsRemoveMerchantsAndCategoriesRequest {
  patchManyExternalDealFiltersDTO: PatchManyExternalDealFiltersDTO;
}

export interface PatchManyEdfsSearchQueryRequest {
  patchManyExternalDealFiltersSearchQueryDTO: PatchManyExternalDealFiltersSearchQueryDTO;
}

export interface PatchSetDealsOfflineOrDecoupleByValidityRequest {
  externalDealFilterId: number;
  externalDealFilterMvoDTO: ExternalDealFilterMvoDTO;
}

export interface PatchSetManyEdfOnlineOrOfflineRequest {
  patchManyExternalDealFiltersLiveDTO: PatchManyExternalDealFiltersLiveDTO;
}

export interface PutExternalDealFilterRequest {
  externalDealFilterId: number;
  inExternalDealFilterDTO: InExternalDealFilterDTO;
}

/**
 *
 */
export class ExternalDealFiltersApi extends runtime.BaseAPI {
  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async createExternalDealFilterRaw(
    requestParameters: CreateExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutExternalDealFilterDTO>> {
    if (
      requestParameters.createExternalDealFilterDTO === null ||
      requestParameters.createExternalDealFilterDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "createExternalDealFilterDTO",
        "Required parameter requestParameters.createExternalDealFilterDTO was null or undefined when calling createExternalDealFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateExternalDealFilterDTOToJSON(requestParameters.createExternalDealFilterDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutExternalDealFilterDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async createExternalDealFilter(
    requestParameters: CreateExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutExternalDealFilterDTO> {
    const response = await this.createExternalDealFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async deleteExternalDealFilterRaw(
    requestParameters: DeleteExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.externalDealFilterId === null || requestParameters.externalDealFilterId === undefined) {
      throw new runtime.RequiredError(
        "externalDealFilterId",
        "Required parameter requestParameters.externalDealFilterId was null or undefined when calling deleteExternalDealFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/externalDealFilters/{externalDealFilterId}`.replace(
          `{${"externalDealFilterId"}}`,
          encodeURIComponent(String(requestParameters.externalDealFilterId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteExternalDealFilter(
    requestParameters: DeleteExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteExternalDealFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async deleteManyExternalDealFiltersRaw(
    requestParameters: DeleteManyExternalDealFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DeleteManyExternalDealFiltersResponseDTO>> {
    if (
      requestParameters.deleteManyExternalDealFiltersDTO === null ||
      requestParameters.deleteManyExternalDealFiltersDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "deleteManyExternalDealFiltersDTO",
        "Required parameter requestParameters.deleteManyExternalDealFiltersDTO was null or undefined when calling deleteManyExternalDealFilters."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/bulk/delete`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteManyExternalDealFiltersDTOToJSON(requestParameters.deleteManyExternalDealFiltersDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DeleteManyExternalDealFiltersResponseDTOFromJSON(jsonValue)
    );
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async deleteManyExternalDealFilters(
    requestParameters: DeleteManyExternalDealFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DeleteManyExternalDealFiltersResponseDTO> {
    const response = await this.deleteManyExternalDealFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async duplicateManyExternalDealFilterRaw(
    requestParameters: DuplicateManyExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ExternalDealFilterListResponseMvoDTO>> {
    if (
      requestParameters.duplicateExternalDealFiltersDTO === null ||
      requestParameters.duplicateExternalDealFiltersDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "duplicateExternalDealFiltersDTO",
        "Required parameter requestParameters.duplicateExternalDealFiltersDTO was null or undefined when calling duplicateManyExternalDealFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/duplicate`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DuplicateExternalDealFiltersDTOToJSON(requestParameters.duplicateExternalDealFiltersDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalDealFilterListResponseMvoDTOFromJSON(jsonValue)
    );
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async duplicateManyExternalDealFilter(
    requestParameters: DuplicateManyExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ExternalDealFilterListResponseMvoDTO> {
    const response = await this.duplicateManyExternalDealFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getExternalDealFilterByIdRaw(
    requestParameters: GetExternalDealFilterByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutExternalDealFilterDTO>> {
    if (requestParameters.externalDealFilterId === null || requestParameters.externalDealFilterId === undefined) {
      throw new runtime.RequiredError(
        "externalDealFilterId",
        "Required parameter requestParameters.externalDealFilterId was null or undefined when calling getExternalDealFilterById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/externalDealFilters/{externalDealFilterId}`.replace(
          `{${"externalDealFilterId"}}`,
          encodeURIComponent(String(requestParameters.externalDealFilterId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutExternalDealFilterDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getExternalDealFilterById(
    requestParameters: GetExternalDealFilterByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutExternalDealFilterDTO> {
    const response = await this.getExternalDealFilterByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getExternalDealFiltersRaw(
    requestParameters: GetExternalDealFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ExternalDealFilterListResponseDTO>> {
    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.filterQuery !== undefined) {
      queryParameters["filterQuery"] = requestParameters.filterQuery;
    }

    if (requestParameters.sortBy !== undefined) {
      queryParameters["sortBy"] = requestParameters.sortBy;
    }

    if (requestParameters.sortOrder !== undefined) {
      queryParameters["sortOrder"] = requestParameters.sortOrder;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/externalDealFilters`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => ExternalDealFilterListResponseDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getExternalDealFilters(
    requestParameters: GetExternalDealFiltersRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ExternalDealFilterListResponseDTO> {
    const response = await this.getExternalDealFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchExternalDealFilterRaw(
    requestParameters: PatchExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutExternalDealFilterDTO>> {
    if (requestParameters.externalDealFilterId === null || requestParameters.externalDealFilterId === undefined) {
      throw new runtime.RequiredError(
        "externalDealFilterId",
        "Required parameter requestParameters.externalDealFilterId was null or undefined when calling patchExternalDealFilter."
      );
    }

    if (
      requestParameters.externalDealFilterMvoDTO === null ||
      requestParameters.externalDealFilterMvoDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "externalDealFilterMvoDTO",
        "Required parameter requestParameters.externalDealFilterMvoDTO was null or undefined when calling patchExternalDealFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/{externalDealFilterId}`.replace(
          `{${"externalDealFilterId"}}`,
          encodeURIComponent(String(requestParameters.externalDealFilterId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: ExternalDealFilterMvoDTOToJSON(requestParameters.externalDealFilterMvoDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutExternalDealFilterDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchExternalDealFilter(
    requestParameters: PatchExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutExternalDealFilterDTO> {
    const response = await this.patchExternalDealFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchManyEdfsAddMerchantsAndCategoriesRaw(
    requestParameters: PatchManyEdfsAddMerchantsAndCategoriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ExternalDealFilterListResponseMvoDTO>> {
    if (
      requestParameters.patchManyExternalDealFiltersDTO === null ||
      requestParameters.patchManyExternalDealFiltersDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "patchManyExternalDealFiltersDTO",
        "Required parameter requestParameters.patchManyExternalDealFiltersDTO was null or undefined when calling patchManyEdfsAddMerchantsAndCategories."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/relations/add`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchManyExternalDealFiltersDTOToJSON(requestParameters.patchManyExternalDealFiltersDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalDealFilterListResponseMvoDTOFromJSON(jsonValue)
    );
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchManyEdfsAddMerchantsAndCategories(
    requestParameters: PatchManyEdfsAddMerchantsAndCategoriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ExternalDealFilterListResponseMvoDTO> {
    const response = await this.patchManyEdfsAddMerchantsAndCategoriesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchManyEdfsRemoveMerchantsAndCategoriesRaw(
    requestParameters: PatchManyEdfsRemoveMerchantsAndCategoriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ExternalDealFilterListResponseMvoDTO>> {
    if (
      requestParameters.patchManyExternalDealFiltersDTO === null ||
      requestParameters.patchManyExternalDealFiltersDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "patchManyExternalDealFiltersDTO",
        "Required parameter requestParameters.patchManyExternalDealFiltersDTO was null or undefined when calling patchManyEdfsRemoveMerchantsAndCategories."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/relations/remove`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchManyExternalDealFiltersDTOToJSON(requestParameters.patchManyExternalDealFiltersDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalDealFilterListResponseMvoDTOFromJSON(jsonValue)
    );
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchManyEdfsRemoveMerchantsAndCategories(
    requestParameters: PatchManyEdfsRemoveMerchantsAndCategoriesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ExternalDealFilterListResponseMvoDTO> {
    const response = await this.patchManyEdfsRemoveMerchantsAndCategoriesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchManyEdfsSearchQueryRaw(
    requestParameters: PatchManyEdfsSearchQueryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ExternalDealFilterListResponseMvoDTO>> {
    if (
      requestParameters.patchManyExternalDealFiltersSearchQueryDTO === null ||
      requestParameters.patchManyExternalDealFiltersSearchQueryDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "patchManyExternalDealFiltersSearchQueryDTO",
        "Required parameter requestParameters.patchManyExternalDealFiltersSearchQueryDTO was null or undefined when calling patchManyEdfsSearchQuery."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/bulk/searchQuery`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchManyExternalDealFiltersSearchQueryDTOToJSON(
          requestParameters.patchManyExternalDealFiltersSearchQueryDTO
        )
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalDealFilterListResponseMvoDTOFromJSON(jsonValue)
    );
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchManyEdfsSearchQuery(
    requestParameters: PatchManyEdfsSearchQueryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ExternalDealFilterListResponseMvoDTO> {
    const response = await this.patchManyEdfsSearchQueryRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchSetDealsOfflineOrDecoupleByValidityRaw(
    requestParameters: PatchSetDealsOfflineOrDecoupleByValidityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.externalDealFilterId === null || requestParameters.externalDealFilterId === undefined) {
      throw new runtime.RequiredError(
        "externalDealFilterId",
        "Required parameter requestParameters.externalDealFilterId was null or undefined when calling patchSetDealsOfflineOrDecoupleByValidity."
      );
    }

    if (
      requestParameters.externalDealFilterMvoDTO === null ||
      requestParameters.externalDealFilterMvoDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "externalDealFilterMvoDTO",
        "Required parameter requestParameters.externalDealFilterMvoDTO was null or undefined when calling patchSetDealsOfflineOrDecoupleByValidity."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/{externalDealFilterId}/setDealsOfflineOrDecoupleByValidity`.replace(
          `{${"externalDealFilterId"}}`,
          encodeURIComponent(String(requestParameters.externalDealFilterId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: ExternalDealFilterMvoDTOToJSON(requestParameters.externalDealFilterMvoDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchSetDealsOfflineOrDecoupleByValidity(
    requestParameters: PatchSetDealsOfflineOrDecoupleByValidityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.patchSetDealsOfflineOrDecoupleByValidityRaw(requestParameters, initOverrides);
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchSetManyEdfOnlineOrOfflineRaw(
    requestParameters: PatchSetManyEdfOnlineOrOfflineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ExternalDealFilterListResponseMvoDTO>> {
    if (
      requestParameters.patchManyExternalDealFiltersLiveDTO === null ||
      requestParameters.patchManyExternalDealFiltersLiveDTO === undefined
    ) {
      throw new runtime.RequiredError(
        "patchManyExternalDealFiltersLiveDTO",
        "Required parameter requestParameters.patchManyExternalDealFiltersLiveDTO was null or undefined when calling patchSetManyEdfOnlineOrOffline."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/setManyEdfOnlineOrOffline`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchManyExternalDealFiltersLiveDTOToJSON(requestParameters.patchManyExternalDealFiltersLiveDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExternalDealFilterListResponseMvoDTOFromJSON(jsonValue)
    );
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async patchSetManyEdfOnlineOrOffline(
    requestParameters: PatchSetManyEdfOnlineOrOfflineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ExternalDealFilterListResponseMvoDTO> {
    const response = await this.patchSetManyEdfOnlineOrOfflineRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async putExternalDealFilterRaw(
    requestParameters: PutExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutExternalDealFilterDTO>> {
    if (requestParameters.externalDealFilterId === null || requestParameters.externalDealFilterId === undefined) {
      throw new runtime.RequiredError(
        "externalDealFilterId",
        "Required parameter requestParameters.externalDealFilterId was null or undefined when calling putExternalDealFilter."
      );
    }

    if (requestParameters.inExternalDealFilterDTO === null || requestParameters.inExternalDealFilterDTO === undefined) {
      throw new runtime.RequiredError(
        "inExternalDealFilterDTO",
        "Required parameter requestParameters.inExternalDealFilterDTO was null or undefined when calling putExternalDealFilter."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/externalDealFilters/{externalDealFilterId}`.replace(
          `{${"externalDealFilterId"}}`,
          encodeURIComponent(String(requestParameters.externalDealFilterId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: InExternalDealFilterDTOToJSON(requestParameters.inExternalDealFilterDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutExternalDealFilterDTOFromJSON(jsonValue));
  }

  /**
   */
  async putExternalDealFilter(
    requestParameters: PutExternalDealFilterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutExternalDealFilterDTO> {
    const response = await this.putExternalDealFilterRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const GetExternalDealFiltersSortByEnum = {
  id: "id",
  nextRunAtDate: "nextRunAtDate"
} as const;
export type GetExternalDealFiltersSortByEnum =
  typeof GetExternalDealFiltersSortByEnum[keyof typeof GetExternalDealFiltersSortByEnum];
/**
 * @export
 */
export const GetExternalDealFiltersSortOrderEnum = {
  ASC: "ASC",
  DESC: "DESC"
} as const;
export type GetExternalDealFiltersSortOrderEnum =
  typeof GetExternalDealFiltersSortOrderEnum[keyof typeof GetExternalDealFiltersSortOrderEnum];
